import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { filterCartItemsByStoreOptionSelections } from '@/modules/Cart/StoreCart/helpers/storeCartOptionSelection.utils';
import { isStoreCartSetupStoreDisabled } from '@/modules/Cart/StoreCart/helpers/storeCartSetup.utils';
import { useAppSelector } from '@/store/hooks';

export const useIsStoreCartSetupDisabled = (): boolean => {
  const { watch } = useFormContext();
  const optionSelectionsByGroupKey = useAppSelector(
    (state) => state.storeCart.optionSelectionsByGroupKey
  );
  const designGroupApiStatusByKey = useAppSelector(
    (state) => state.storeCart.designGroupApiStatusByKey
  );

  return useMemo(() => {
    const cartDetails = watch('cartDetails') ?? [];
    const filteredCartItems = filterCartItemsByStoreOptionSelections(
      cartDetails,
      optionSelectionsByGroupKey
    );

    return isStoreCartSetupStoreDisabled(filteredCartItems, designGroupApiStatusByKey);
  }, [watch, designGroupApiStatusByKey, optionSelectionsByGroupKey]);
};
